import { useCallback } from 'react'

import { HandbookV2 } from 'types'
import { useLoading } from 'hooks/UseLoading'
import * as client from 'api/clients/HandbookClient'
import { syncHandbookStore } from 'components/Handbook2_0/util'
import { useHandbook } from '../hooks'
import { HandbooksStore } from 'stores/HandbooksStore'

export function useUpdateHandbook(handbook: HandbookV2 | null, store: HandbooksStore) {
  const currentHandbook = useHandbook()
  const [wrappedUpdate, loading] = useLoading(client.updateHandbook)

  const needSync = currentHandbook?.id === handbook?.id

  const updateHandbook = useCallback(
    async (values: Partial<HandbookV2>): Promise<[string, string][] | undefined> => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const res = await wrappedUpdate(handbook!, values)

      switch ('status' in res && res.status) {
        case 200:
          if (needSync) syncHandbookStore(res.data.handbook, store)
          return

        case 400:
          // Parse server-side validation errors
          return res.data.errors.map((error: { detail: string; source: { pointer: string } }) => {
            const attr = error.source.pointer.split('/').pop()
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return [attr!, error.detail] as [string, string]
          })
      }

      throw new Error('Something went wrong, try again')
    },
    [wrappedUpdate, handbook, needSync, store],
  )

  return [updateHandbook, loading] as [typeof updateHandbook, boolean]
}
